import { styles } from "../TestimonialModule.style";

export interface TestimonialItemData {
  text: string;
  customerName: string;
  location: string;
}

export interface TestimonialItemProps {
  item: TestimonialItemData;
  isHidden?: boolean;
}

export const TestimonialItem = ({ item, isHidden }: TestimonialItemProps) => (
  <li className={styles.card} aria-hidden={isHidden ? true : undefined}>
    <span className={styles.cardSeparator} aria-hidden="true" />
    <figure className={styles.figure}>
      <blockquote className={styles.blockquote}>
        <span className={styles.quoteGlyphWrapper} aria-hidden="true">
          <span className={styles.quoteGlyph}>&ldquo;</span>
        </span>
        <p className={styles.quoteText}>{item.text}</p>
      </blockquote>
      <figcaption className={styles.figcaption}>
        <span className={styles.dividerWrapper} aria-hidden="true">
          <span className={styles.divider} />
        </span>
        <span className={styles.customerName}>{item.customerName}</span>
        <span className={styles.location}>{item.location}</span>
      </figcaption>
    </figure>
  </li>
);
